import React from "react";

const AddPlus: React.FC<React.SVGProps<SVGSVGElement>> = ({
  fill = "var(--icon)",
  ...rest
}) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M8.325 9.675H4.5V8.325H8.325V4.5H9.675V8.325H13.5V9.675H9.675V13.5H8.325V9.675Z"
        fill={fill}
      />
    </svg>
  );
};

export default AddPlus;
